<div class="jumbotron">
    <h1 class="text-center">{{ i18n._7206_REPORT | translate }}</h1>
    <cmps-client-logo></cmps-client-logo>
</div>
<div class="tdcf-content">
    <cmps-wait-status *ngIf="state?.pendingMetadata"></cmps-wait-status>

    <form
        [name]="form.name"
        [formGroup]="form.form"
        (ngSubmit)="onSubmit()"
        *ngIf="!state?.pendingMetadata"
    >
        <div class="form-group">
            <ng-select
                [options]="reviewDateRangeOpts"
                [id]="form.fields.DATE_RANGES.id"
                [placeholder]="form.fields.DATE_RANGES.placeholder | translate"
                [ariaLabel]="form.fields.DATE_RANGES.label | translate"
                [notFoundMsg]="i18n._7413_NO_RESULTS_FOUND | translate"
                [selectAllLabel]="i18n._994_SELECT_ALL | translate"
                [allOptionsSelectedLabel]="
                    i18n._7226_ALL_OPTIONS_SELECTED | translate
                "
                [multiple]="false"
                [multipleWithCheckbox]="true"
                [formControlName]="form.fields.DATE_RANGES.name"
            ></ng-select>
        </div>
        <button
            type="submit"
            class="btn btn-primary"
        >
            {{ i18n._7207_GENERATE | translate }}
        </button>
    </form>

    <div
        class="alert alert-warning"
        role="alert"
        *ngIf="form.errors.DATE_RANGES"
    >
        {{ form.errors.DATE_RANGES }}
    </div>

    <cmps-wait-status *ngIf="state?.pendingData"></cmps-wait-status>

    <div
        cmpsTdcfReportManagerTable
        [directTeamOnly]="directTeamOnly"
        *ngIf="!state?.pendingData && state?.pendingData != null"
    ></div>
</div>
